<template>
  <div>
    <div class="flex-content">
      <div
        id="chartGJC"
        :style="{
          width: '55%',
          height: '420px'
        }"
      />
      <PortalCommonTable
        class="GJCTable"
        no-pagination
        align-text="left"
        serial-text="排名"
        :table-data="GJCTableData"
        :column-data="GJCColumnData"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PortalCommonTable from "./PortalCommonTable.vue";
import {
    GetKeywords
} from "@/api/portal";
export default {
  name: "keyWords",
  props: {
    year: {
      type: String,
      default: ""
    }
  },
  components: {
    PortalCommonTable
  },
  computed: {
    ...mapGetters({
      magId: "magId"
    })
  },
  data() {
    return {
        GJCTableData: [],
      GJCColumnData: [
        {
          title: '关键词',
          prop: 'keywords',
          notSortable: true
        },
        {
          title: '频次',
          prop: 'count',
          notSortable: true,
          width: '50px',
          align: 'center'
        }
      ],
    };
  },
  watch: {
    year: {
      handler(newVal) {
        if (newVal.length > 0) {
          this.getKeywords();
        }
      },
      deep: true
    },
    magId(nv) {
      if (nv) {
        this.getKeywords();
      }
    }
  },
  methods: {
    getKeywords() {
      const params = {
        magId: this.magId,
        year: this.year
      };
      return new Promise(resolve => {
        GetKeywords(params).then(res => {
          if (res && res.data && res.data.status === 0) {
            const { data } = res.data;
            this.GJCTableData = data;
            this.chartGJC(data);
            resolve();
          }
        });
      });
    },
    chartGJC(data) {
      if (!document.getElementById("chartGJC")) {
        return;
      }
      const myChart = this.$echarts.init(document.getElementById("chartGJC"));
      let list = [];
      if (data && data.length > 0) {
        list = data;
        list.map(item => {
          item.name = item.keywords;
          item.value = item.count;
        });
      }
      myChart.setOption(
        {
          //数据可以点击
          tooltip: {},
          series: [
            {
              // maskImage: maskResource,
              //词的类型
              type: "wordCloud",
              //设置字符大小范围
              sizeRange: [16, 70],
              size: ["100%", "100%"],
              rotationRange: [-90, 90],
              width: "95%",
              height: "95%",
              gridSize: 4,
              textStyle: {
                normal: {
                  //生成随机的字体颜色
                  color: () => {
                    return (
                      "rgb(" +
                      [
                        Math.round(Math.random() * 160),
                        Math.round(Math.random() * 160),
                        Math.round(Math.random() * 160)
                      ].join(",") +
                      ")"
                    );
                  }
                }
              },
              //不要忘记调用数据
              data: list
            }
          ]
        },
        true
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.flex-content {
  display: flex;
  justify-content: space-between;
  gap: 0 20px;
  .left-content,
  .right-content {
    // width: 49%;
    flex: 1;
  }
}
.GJCTable {
            width: 35%;
          }
</style>
